module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "grid-option weex-ct weex-div",
    style: (_vm._px2rem(_vm.cWrapperStyle, 75)),
    attrs: {
      "accessible": true,
      "aria-label": (_vm.title + "," + (_vm.checked?'已选中':'未选中')),
      "weex-type": "div",
      "data-evt-click": ""
    },
    on: {
      "click": _vm.$stopOuterA,
      "weex$tap": function($event) {
        $event.stopPropagation();
        return _vm.onClick($event)
      }
    }
  }, [(_vm.title) ? _c('p', {
    staticClass: "text-title weex-el weex-text",
    style: (_vm._processExclusiveStyle(_vm.cTitleStyle, 75, 'text')),
    attrs: {
      "weex-type": "text"
    }
  }, [_vm._v(_vm._s(_vm.title))]) : _vm._e(), _vm._v(" "), (_vm.checked && _vm.icon) ? _c('figure', {
    staticClass: "image-checked weex-el weex-image",
    attrs: {
      "src": _vm.icon,
      "data-img-src": _vm.icon,
      "weex-type": "image"
    }
  }) : _vm._e()])
},staticRenderFns: []}
module.exports.render._withStripped = true
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-c13907ce", module.exports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-c13907ce","hasScoped":true}!./~/vue-loader/lib/selector.js?type=template&index=0!./packages/dof-grid-select/option.vue
// module id = 656
// module chunks = 0 1